import { formataTelefone } from '../../../../utils';

type State = {
	idGrupoAcesso: number;
	nome: string;
	email: string;
	telefone: string;
	senha: string;
	confirmacaoSenha: string;
	tagAtivo: string;
	concessionarias: number[];
	revenda: number;
	tagNaoComprar: string;
	tagReceberEmail: string;
	tagReceberPush: string;
};

type Action =
	| { type: 'SET_VALUE'; field: string; payload: string | number }
	| { type: 'SET_SELECT_OPTION'; field: string; value: string | number }
	| { type: 'SET_MULTISELECT_OPTION'; field: string; value: number[] }
	| { type: 'REPLACE_STATE'; payload: State };

export const newUserFormInitialState: State = {
	idGrupoAcesso: 0,
	nome: '',
	email: '',
	telefone: '',
	senha: '',
	confirmacaoSenha: '',
	tagAtivo: '',
	concessionarias: [],
	revenda: 0,
	tagNaoComprar: '',
	tagReceberEmail: '',
	tagReceberPush: '',
};

export const newUserFormReducer = (state: State, action: Action) => {
	switch (action.type) {
		case 'SET_VALUE':
			let valor = action.payload;

			if (action.field === 'telefone') {
				valor = formataTelefone(action.payload as string);
			}

			return {
				...state,
				[action.field]: valor,
			};
		case 'SET_SELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		case 'SET_MULTISELECT_OPTION':
			return {
				...state,
				[action.field]: action.value,
			};
		case 'REPLACE_STATE':
			return { ...action.payload, telefone: formataTelefone(action.payload.telefone) };
		default:
			return state;
	}
};
